import { hookstate } from '@hookstate/core';
import productHelpers from '~/helpers/product';
import { LOCALE } from '~/store/States/global';
import { apiCategories } from '~/store/Query/api';

export const CARACT = 'C';
export const FICHA = 'F';

export const attributeOrderProduct = hookstate(CARACT);

export const attributeOrderGeneric = hookstate(CARACT);

export const attributeOrderPospago = hookstate(CARACT);

export async function setAttributeOrder(attributeOrder, item, attrMap) {
  const attr = attrMap || productHelpers.convertAttributes(item.attributes);
  const attrOrden = attr['attr-conf-orden-atributos'];
  if (attrOrden) {
    attributeOrder.set(attrOrden);
    return;
  }
  const cats = await apiCategories();
  if (cats.ok) {
    let map = cats.body._map;
    if (!map) {
      map = new Map();
      cats.body.forEach((cat) => {
        map.set(cat.external_referrer, cat);
      });
      cats.body._map = map;
    }
    const { categories } = item.locales[LOCALE];
    let attribute_order = null;
    for (let i = 0; i < categories.length; i += 1) {
      const category = map.get(categories[i].slug);
      if (category?.attribute_order) {
        attribute_order = category.attribute_order;
        break;
      }
    }
    attributeOrder.set(attribute_order || CARACT);
  }
}
